<template>
  <div>
    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ titleOrFallback }}</title>
      <meta name="title" :content="titleOrFallback" />
      <meta name="description" :content="descriptionOrFallback" />

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website" />
      <meta property="og:url" :content="currentPageURL" />
      <meta property="og:title" :content="titleOrFallback" />
      <meta property="og:description" :content="descriptionOrFallback" />
      <meta property="og:image" :content="props.image" v-if="props.image" />

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" :content="currentPageURL" />
      <meta property="twitter:title" :content="titleOrFallback" />
      <meta property="twitter:description" :content="descriptionOrFallback" />
      <meta
        property="twitter:image"
        :content="props.image"
        v-if="props.image"
      />
    </Head>
    <div
      class="bg-white h-[100dvh] landscape:h-screen items-stretch grid grid-cols-1 lg:grid-cols-2"
    >
      <div class="w-full overflow-y-auto">
        <div
          class="px-4 xl:px-40 sm:py-8 sm:px-8 min-h-full relative flex flex-col"
        >
          <logo class="hidden sm:block w-36" />
          <div
            class="bg-white sm:flex-1 flex flex-col gap-y-8 justify-center my-6 w-full"
          >
            <div class="mx-auto w-full max-w-90">
              <logo-short class="sm:hidden" />
            </div>
            <slot />
          </div>
          <div class="hidden sm:flex justify-between items-center text-sm">
            <div>
              {{ t("auth.layout.fixform") }} {{ new Date().getFullYear() }}
            </div>
            <div class="flex items-center gap-0.5 text-tertiary">
              <a href="mailto:help@fixform.com">help@fixform.com</a>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bg-gradient-45 from-[#0D4B9B] to-[#0683FF] flex-1 overflow-hidden hidden lg:flex flex-col items-center justify-center gap-6"
      >
        <div
          class="bg-auth-layout flex-1 bg-contain bg-no-repeat bg-center max-h-[400px] max-w-[400px] w-full"
        />
        <div
          class="flex items-center justify-center flex-col px-8 max-w-[640px]"
        >
          <p
            class="text-4xl font-semibold text-white text-center mb-6 leading-[44px]"
          >
            {{ t("auth.layout.description") }}
          </p>
          <div class="flex flex-col gap-2 items-center justify-between">
            <div class="flex">
              <Star
                v-for="(_, index) in Array.from({ length: 5 })"
                :key="index"
                class="text-white"
              />
            </div>
            <div>
              <div class="text-white text-lg">
                {{ t("auth.layout.admin_name") }}
              </div>
              <div class="text-white">
                {{ t("auth.layout.admin_role") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Head } from "@inertiajs/vue3";
import { computed, defineProps } from "vue";
import Star from "./Icon/Star.vue";
import { useI18n } from "vue-i18n";
import Logo from "@/Tailwind/Components/Logo";
import LogoShort from "./Icon/LogoShort.vue";

const i18n = useI18n();
const t = i18n.t;

const props = defineProps({
  title: String,
  description: String,
});

const currentPageURL = window.location.href;
const titleOrFallback = computed(() =>
  props.title ? `FixForm - ${props.title}` : "FixForm"
);
const descriptionOrFallback = computed(
  () =>
    props.description ||
    "Keep buildings and spaces in good, safe and clean condition"
);
</script>
